import type React from 'react';
// eslint-disable-next-line jira/import-whitelist
import { registerEvent } from '@atlassian/server-to-client-comms/server-receiver';

// eslint-disable-next-line jira/import-whitelist
import { useIsStagingOrDevOrLocal } from '@atlassian/jira-tenant-context-controller/src/components/environment/index.tsx';

type SSRFailureProps = {
	displayErrorInStaging?: boolean;

	/** Slack channel to report SSR failures to */
	reportToSlackChannel?: string;

	/** A key to identify where failure came from */
	fallbackId?: string;

	/** Indicates this is a cookie circuit breaker failure */
	isCookieCircuitBreakerFailure?: boolean;

	/** Cookie key for circuit breaker (used to delete the cookie) */
	cookieKey?: string;
};

const pushSSRFailureDisplay = (failureProps: SSRFailureProps): void => {
	registerEvent({
		id: 'ssr-failure-display',
		name: 'onSSRFailureDisplay',
		args: [failureProps],
	});
};

/**
 * A declarative component that taints a given location as a "fallback"
 * used to detect SSR success rate and the completeness of the page.
 *
 * Duplicated from @jira/ssr__rendering-guard to avoid the dependency.
 */
export const FallbackIndicator = ({
	reportToSlackChannel,
	fallbackId,
	displayErrorInStaging,
	isCookieCircuitBreakerFailure,
	cookieKey,
}: SSRFailureProps): React.JSX.Element | null => {
	const isStagingOrDevOrLocal = useIsStagingOrDevOrLocal();

	// eslint-disable-next-line jira/jira-ssr/no-server-variable
	if (__SERVER__) {
		if (displayErrorInStaging && isStagingOrDevOrLocal) {
			pushSSRFailureDisplay({
				reportToSlackChannel,
				fallbackId,
				displayErrorInStaging,
				isCookieCircuitBreakerFailure,
				cookieKey,
			});
		}
	}
	return null;
};
